import { Box, Collapse, TablePagination, Typography } from '@mui/material';
import { ClientInfoModel } from '../../model/clitent-model';
import { ClientControllerAction, ClientControllerState } from '../../controller/client-controller';
import {
  CustomAlertAction,
  CustomAlertState,
} from '../../../../alert/controller/custom.alert.controller';
import { ClientTableTitle } from '../../data/client-table-title';
import lineLoader from '../../../../components/lineLoader/lineLoader';
import ClientMunuOption from './../../data/client-menu-option';
import { ClientOptionData } from '../../data/client-option-data';

const defaultStyle = { border: '1px solid #1A1A1A20', padding: '8px' };

const ClientTable = ({
  client,
  alert,
}: {
  client: ClientControllerAction & ClientControllerState;
  alert: CustomAlertAction & CustomAlertState;
}) => {
  return (
    <Box sx={{ overflowX: 'auto' }}>
      <Collapse unmountOnExit={true} orientation={'vertical'} in={client.loading ? true : false}>
        {lineLoader()}
      </Collapse>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            {ClientTableTitle?.map((label, index) => (
              <th key={index} style={{ ...defaultStyle, backgroundColor: '#E4E8F3' }}>
                {label.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {client?.listUser?.map((userData: ClientInfoModel, index: number) => (
            <tr key={index}>
              <td style={{ ...defaultStyle, textAlign: 'center' }}>
                {(client?.page ?? 0) * (client?.pageRowAmount ?? 10) + index + 1}
              </td>
              <td style={{ ...defaultStyle, textAlign: 'center' }}>
                {userData?.first_name} {userData?.last_name}
              </td>

              <td style={{ ...defaultStyle, textAlign: 'center' }}>{userData?.phone}</td>

              <td style={{ ...defaultStyle, textAlign: 'center' }}>
                {client?.listPosition?.find((p) => p.uuid === userData?.position_id)
                  ?.position_name_la ?? '-'}
              </td>

              <td style={{ ...defaultStyle, textAlign: 'center' }}>
                {client?.listMinistry?.find((m) => m.uuid === userData?.ministry_id)?.title_la ??
                  '-'}
              </td>

              <td style={{ ...defaultStyle, textAlign: 'center' }}>
                {client?.listProvince?.find((p) => p.uuid === userData?.province_id)?.title_la ??
                  '-'}
              </td>

              <td style={{ ...defaultStyle, textAlign: 'center' }}>
                {client?.listDepartment?.find((d) => d.uuid === userData?.department_id)
                  ?.title_la ?? '-'}
              </td>

              <td style={{ ...defaultStyle, textAlign: 'center' }}>
                {client?.listRoles?.find((r) => r.id === userData?.role_id)?.role_name ?? '-'}
              </td>
              <td style={{ ...defaultStyle, textAlign: 'center' }}>
                <ClientMunuOption
                  userData={userData}
                  listMenu={ClientOptionData({ ctrl: client, alert: alert })}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 3,
          py: 2,
        }}
      >
        <Typography>ຜູ້ໃຊ້ທັງໝົດ {client?.listCount} ຄົນ</Typography>

        <TablePagination
          component="div"
          colSpan={3}
          rowsPerPageOptions={[10, 25, 50, 100]}
          count={client?.listCount}
          page={client?.page}
          onPageChange={(_, newPage) => {
            client?.onPageChange(newPage, client?.pageRowAmount);
            client?.clientGetData(true, {
              ...client?.filter,
              skip: client?.pageRowAmount * newPage,
              take: client?.pageRowAmount,
            });
          }}
          rowsPerPage={client?.pageRowAmount ?? 10}
          onRowsPerPageChange={(e) => {
            client?.onPageChange(0, Number.parseInt(e.target.value));
            client?.onFilterChange({ skip: 0, take: Number.parseInt(e.target.value) });
            client?.clientGetData(true, { skip: 0, take: Number.parseInt(e.target.value) });
          }}
        />
      </Box>
    </Box>
  );
};

export default ClientTable;
